const additionalCode = '';

/** Включение webvisor на всех страницах */
const enableWebvisorAllPages = true;

/**
 * Страницы, на которых должен быть включён webvisor (если enableWebvisorAllPages=false)
 * @example ['/sme/']
 *  */
const webvisorPages = [];

const utmForwardingPages = [
    '/alfafuture/event/excursion/',
    '/alfafuture/event/camp/',
    '/alfafuture/fest/'
];

module.exports = {
    additionalCode,
    enableWebvisorAllPages,
    webvisorPages,
    utmForwardingPages
};
